/** Shared kickoff formatting for user-facing match lists. */

function resolveDateLocale(locale = 'en') {
  if (locale === 'pt') return 'pt-PT';
  // Always pin English — never fall back to the browser locale (e.g. ru-RU)
  return 'en-GB';
}

export function formatKickoffDateTime(iso, locale = 'en') {
  if (!iso) return { date: '—', time: '—', label: '—' };
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { date: '—', time: '—', label: '—' };

  const loc = resolveDateLocale(locale);
  const date = d.toLocaleDateString(loc, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
  const time = d.toLocaleTimeString(loc, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  return { date, time, label: `${date} · ${time}` };
}

export function matchDayKey(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
  return d.toISOString().slice(0, 10);
}

export function formatDayHeading(isoDate, locale = 'en') {
  const d = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(d.getTime())) return isoDate;
  const loc = resolveDateLocale(locale);
  return d.toLocaleDateString(loc, {
    weekday: 'short',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}
